module.exports = __webpack_public_path__ + "media/images/502-12b66b464221f7bda13d1e6358ed6c0d.svg";